import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { imageSources } from 'apps/find-designers/propTypes';
import DesignGalleryItem from './DesignGalleryItem';

class DesignGallery extends Component {
    item(_, index) {
        const design = this.props.designs[index];

        if (!design) {
            return <div className="design-gallery__item" key={uuid()} />;
        }

        return (
            <div className="design-gallery__item" key={uuid()}>
                <DesignGalleryItem
                    imageSources={design.imageSources}
                    alt={design.title}
                    title={design.description}
                    designUrl={design.designUrl}
                />
            </div>
        );
    }

    render() {
        return <div className="design-gallery">{[...Array(3)].map(this.item, this)}</div>;
    }
}

DesignGallery.defaultProps = {
    designs: [],
};

DesignGallery.propTypes = {
    designs: PropTypes.arrayOf(
        PropTypes.shape({
            imageSources: imageSources.isRequired,
        })
    ),
};

export default DesignGallery;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignGallery.jsx